// Layer 2 (Engine): explicit plant-to-smelter mass basis conversion.
export const SHORT_TON_TO_TONNE = 0.90718474;
export const GRAMS_PER_TROY_OUNCE = 31.1035;

export function shortTonsToTonnes(shortTons: number): number {
  return shortTons * SHORT_TON_TO_TONNE;
}
